// MUI Chip color prop values for ticket status
export const statusColorMap = {
  Open: 'primary',
  'In Progress': 'warning',
  'Waiting for customer': 'info',
  Escalated: 'error',
  Done: 'success',
  Resolved: 'success',
  Closed: 'default',
};
